export default __webpack_public_path__ + "static/media/dds5168b-7.860d1429.png";